import EpcProjectOverview from '../EpcProjectOverview';
import { useEpcProjectDetail } from '../EpcProjectDetailContext';

export default function EpcProjectOverviewTab() {
  const { id, project, hasSchedule, canUpdate } = useEpcProjectDetail();
  if (!project) return null;
  return (
    <EpcProjectOverview projectId={id} project={project} hasSchedule={hasSchedule} canUpdate={canUpdate} />
  );
}
